var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      "modal-dialog-size": "md",
      "footer-close-button-text": _vm.$t("global.words.no"),
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("settings.visibility.resetVisibilitySettings")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", { staticClass: "justified progress-text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("settings.visibility.modal.areYouSure")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", { on: { click: _vm.handleReset } }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("settings.visibility.modal.yesReset")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }